import { SxProps, Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

type TStyles = {
  modalContent: SxProps<Theme>;
  mainPage: SxProps<Theme>;
  mainPageContainer: SxProps<Theme>;
  mainPageContent: SxProps<Theme>;
  mainPageNavigator: SxProps<Theme>;
  mainPageContentNavigator: SxProps<Theme>;
  mainPageContentWrapper: SxProps<Theme>;
  mainPageContentCardWrapper: SxProps<Theme>;
  mainPageContentCardText: SxProps<Theme>;
  mainPageContentCardTextInfo: SxProps<Theme>;
  navigatorButton: (theme: Theme) => SystemStyleObject<Theme>;
};

export const styles: TStyles = {
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },

  mainPage: {
    height: '100%',
    margin: '0',
    overflow: 'hidden',
  },

  mainPageContainer: {
    position: 'relative',
    minHeight: '100vh',
    letterSpacing: '-1px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#F5F5F5',
  },

  mainPageContent: (theme: Theme) => ({
    minHeight: 'calc(100vh - 180px)',
    padding: '20px 110px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      padding: '20px 90px',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 'calc(100vh - 170px)',
      padding: '20px 25px',
    },
  }),

  mainPageNavigator: {
    display: 'flex',
    justifyContent: 'center',
    gap: '7px',
  },

  navigatorButton: (theme: Theme) => ({
    border: 'none',
    background: theme.palette.common.white,
    borderRadius: '5px',
    width: '180px',
    height: '40px',
    color: theme.palette.grey.additionalGrey,
    cursor: 'pointer',
    fontStyle: 'normal',
    fontSize: '15px',
    textAlign: 'center',
    '&:hover, &.active': {
      color: theme.palette.primary.main,
    },
  }),

  mainPageContentNavigator: (theme: Theme) => ({
    textAlign: 'center',
    fontSize: '13px',
    paddingTop: '20px',
    margin: '0 30% 0 30%',
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      margin: '0 15% 0 15%',
    },
  }),

  mainPageContentWrapper: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '&.margin-top-0': {
      marginTop: 0,
      marginBottom: 0,
    },
  },

  mainPageContentCardWrapper: {
    position: 'relative',
    marginTop: 'auto',
    alignSelf: 'flex-end',
    width: '100%',
  },

  mainPageContentCardText: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    '& p': {
      fontWeight: 600,
      fontSize: '16px',
      textAlign: 'center',
      color: theme.palette.primary.main,
    },
    '& hr': {
      flex: 1,
      border: 'none',
      backgroundColor: theme.palette.primary.main,
      height: '1.3px',
    },
  }),

  mainPageContentCardTextInfo: (theme: Theme) => ({
    alignItems: 'center',
    color: theme.palette.primary.main,
  }),
};
